export default {
  environment: process.env.NODE_ENV,
  name: process.env.APP_NAME,
  logTraceKey: '_z_log_tracing',
}
